import { useState, useEffect } from 'react';

/**
 * Custom hook to fetch referral dashboard data from the API
 * @param {number} page - Current page number for pagination
 * @param {number} perPage - Items per page
 * @returns {Object} { data, loading, error, refetch }
 */
export function useReferralData(page = 1, perPage = 5) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      // Get CSRF token from meta tag
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

      const response = await fetch(`/api/referrals/dashboard?page=${page}&per_page=${perPage}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const json = await response.json();
      setData(json);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, perPage]);

  return {
    data,
    loading,
    error,
    refetch: fetchData
  };
}
